import { Button, Grid, IconButton, MenuItem, TextField, Tooltip } from "@material-ui/core";
import { Fragment, useEffect } from "react";
import { inputColor, inputVariant } from "../../../settings/inputConfig";

import DetalleFolio from "./DetalleFolio";
import FolioHelper from "./FolioHelper";
import MeditocActions from "../../utils/MeditocActions";
import MeditocBody from "../../utils/MeditocBody";
import MeditocHeader from "../../utils/MeditocHeader";
import MeditocTable from "../../utils/MeditocTable";
import RefreshIcon from "@material-ui/icons/Refresh";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { fnEmpty } from "../../../settings/preventConfig";
import { getFolioColumns } from "../../../models/FolioModel";
import { useCatalogo } from "../../../context/CatalogoContext";
import { useFolio } from "../../../context/FolioContext";
import { useLogin } from "../../../context/LoginContext";
import { useStyle } from "../../../context/StyleContext";

export default function Folio() {
    const { classes } = useStyle();
    const { entCatalogos } = useCatalogo();
    const { usuarioPermisos } = useLogin();
    const {
        listaProductos,
        listaFolios,
        folioSeleccionado,
        formFiltroFolios,
        handleChangeFolioSeleccionado,
        handleChangeFormFiltroFolios,
        handleClickDetalleFolio,
        handleClickRefrescarDatos,
        handleClickFiltrarFolios,
    } = useFolio();

    const permisos = usuarioPermisos["3"].Submodulos["1"];
    const { txtOrigen, txtProducto, txtVigente } = formFiltroFolios;

    useEffect(() => {
        handleClickRefrescarDatos();
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <MeditocHeader title={permisos.Nombre}>
                {permisos.Botones["1"] && ( //Detalle de folio
                    <Tooltip title={permisos.Botones["1"].Nombre} arrow>
                        <IconButton onClick={handleClickDetalleFolio}>
                            <VisibilityIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
                {permisos.Botones["2"] && ( //Actualizar tabla
                    <Tooltip title={permisos.Botones["2"].Nombre} arrow>
                        <IconButton onClick={handleClickRefrescarDatos}>
                            <RefreshIcon className="color-0" />
                        </IconButton>
                    </Tooltip>
                )}
            </MeditocHeader>
            <MeditocBody>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <MeditocActions title="Filtrar folios" />
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <TextField
                            name="txtOrigen"
                            label={txtOrigen.label}
                            value={txtOrigen.value}
                            onChange={handleChangeFormFiltroFolios}
                            variant={inputVariant}
                            color={inputColor}
                            fullWidth
                            select
                        >
                            <MenuItem value="">Todos</MenuItem>
                            {entCatalogos.catOrigen.map((origen) => (
                                <MenuItem key={origen.fiId.toString()} value={origen.fiId.toString()}>{origen.fsDescripcion}</MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <TextField
                            name="txtProducto"
                            label={txtProducto.label}
                            value={txtProducto.value}
                            onChange={handleChangeFormFiltroFolios}
                            variant={inputVariant}
                            color={inputColor}
                            fullWidth
                            select
                            SelectProps={{
                                MenuProps: {
                                    classes: {
                                        paper: classes.selectMain,
                                    },
                                    PaperProps: {
                                        style: { maxHeight: 400 },
                                    },
                                },
                            }}
                        >
                            <MenuItem value="">Todos los productos</MenuItem>
                            {listaProductos.map((producto) => (
                                <MenuItem key={producto.iIdProducto} value={producto.iIdProducto.toString()}>
                                    <i
                                        className="icon size-20"
                                        dangerouslySetInnerHTML={{
                                            __html: `&#x${producto.sIcon};&nbsp;&nbsp;&nbsp;`,
                                        }}
                                    />
                                    {"   "}
                                    {producto.sNombre}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <TextField
                            name="txtVigente"
                            label={txtVigente.label}
                            value={txtVigente.value}
                            onChange={handleChangeFormFiltroFolios}
                            variant={inputVariant}
                            color={inputColor}
                            fullWidth
                            select
                        >
                            <MenuItem value="">Todos los folios</MenuItem>
                            <MenuItem value="true">Folio activo</MenuItem>
                            <MenuItem value="false">Folio inactivo/vencido</MenuItem>
                        </TextField>
                    </Grid>
                    <Grid item xs={12} className="right">
                        <Button
                            variant="contained"
                            style={{ color: "#555", marginRight: 15 }}
                            onClick={handleClickRefrescarDatos}
                        >
                            Limpiar
                        </Button>
                        <Button variant="contained" color="primary" onClick={handleClickFiltrarFolios}>
                            Filtrar
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <MeditocTable
                            id="iIdFolio"
                            data={listaFolios}
                            row={folioSeleccionado}
                            columns={getFolioColumns()}
                            setRow={handleChangeFolioSeleccionado}
                            fnDoubleClick={permisos.Botones["1"] ? handleClickDetalleFolio : fnEmpty}
                        />
                    </Grid>
                </Grid>
            </MeditocBody>
            <FolioHelper />
            <DetalleFolio />
        </Fragment>
    );
}
